import { DateTime } from "luxon";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { screenShiftsToDateShifts } from "../lib/calculations";
import {
  EquipmentAttributesById,
  GrouppedData,
  DateShift,
  ScreenType,
  ScreenDivisionAttributes
} from "../types/types";

export interface ScreenState {
  monitor: ScreenType | null;
  realTimeDateShift: DateShift| null,
  dateShift: DateShift| null,
  shifts: DateShift[] | null,
  equipments:  EquipmentAttributesById[] | null,
  divisions: ScreenDivisionAttributes | null,
  dataIsLoaded: boolean,
  updateDateTime: DateTime | null;
  startUpdate: boolean;
  isEditMode: boolean;
  isHistory: boolean;
  monitorData: GrouppedData;

  setMonitor: (screen: ScreenType) => void;
  setShifts: (shifts: DateShift[]) => void;
  setRealTimeDateShift: (shift: DateShift) => void;
  setDateShift: (shift: DateShift) => void;
  setDataIsLoaded: (value: boolean) => void;
  setStartUpdate: (value: boolean) => void;
  setIsEditMode: (value: boolean) => void;
  setIsHistory: (value: boolean) => void;
  setMonitorData: (value: GrouppedData) => void;
  setUpdateDateTime: (value: DateTime) => void;
  resetStore: () => void;
}

export const useScreenStore = create<ScreenState>()(
  immer<ScreenState>((set, get) => ({
    monitor: null,
    realTimeDateShift: null,
    dateShift: null,
    shifts: null,
    equipments: null,
    divisions: null,
    dataIsLoaded: false,
    monitorData: {},
    isEditMode: false,
    isHistory: false,
    updateDateTime: null,
    startUpdate: false,
    setMonitor: (screen) =>
      set((state) => {
        state.monitor = screen;
        state.shifts = screenShiftsToDateShifts(screen.attributes.working_shift_relations);
        state.equipments = screen.attributes.equipment_item_relations?.map((item) => item.equipment_item).filter(i => i !== null);
        state.divisions = screen.attributes.division;
      }),
    setRealTimeDateShift:  (dateshift) =>  set((state) => {state.realTimeDateShift = dateshift}),
    setDateShift: (dateshift) =>  set((state) => {state.dateShift = dateshift}),
    setShifts: (shifts) => set((state) => {state.shifts = shifts}),
    setUpdateDateTime: (dt) =>  set((state) => {state.updateDateTime = dt}),
    setDataIsLoaded: (dataIsLoaded) => set((state) => {state.dataIsLoaded = dataIsLoaded}),
    setIsHistory: (value: boolean) => {
      set((state) => {
        state.isHistory = value;
      });
    },
    setIsEditMode: (value: boolean) => {
      set((state) => {
        state.isEditMode = value;
      });
    }, 
    setStartUpdate: (value: boolean) => {
      set((state) => {
        state.startUpdate = value;
      });
    },    
    setMonitorData: (data) => {
      set((state) => {
        state.monitorData = data;
      });
    },
    resetStore: () =>
      set((state) => {
        state.monitor = null;
        state.realTimeDateShift = null;
        state.dateShift = null;
        state.shifts = null;
        state.equipments = null;
        state.divisions = null;
        state.dataIsLoaded = false;
        state.monitorData = {};
        state.isEditMode = false;
        state.isHistory = false;
        state.updateDateTime = DateTime.local().plus({minute: 1});
        state.startUpdate = false;
      }
    ),

  }))
);
